import { lightColors } from '@tryhackme/thm-ui-components';
import type { FC } from 'react';
import { FlashSaleCampaignName } from 'src/common/enums/campaigns';
import { useGetUserQuery } from 'src/common/slices';
import { useGetInfluencersCampaignsQuery } from 'src/features/admin/campaigns/campaigns.slice';
import { useCampaignCta } from 'src/features/campaigns/hooks/use-campaign-cta';
import { ThemeProvider, useTheme } from 'styled-components';
import { Countdown } from '../../components/countdown';
import { useGetAfterSignupFlashSaleEndTime } from '../../hooks/use-get-after-signup-flash-sale-end-time';
import { useInfluencerConfigs } from '../../influencers/hooks/use-influencer-additional-configs';
import { useInfluencerSubscriptionCampaign } from '../../influencers/hooks/use-influencer-campaign';
import { SubscribeButton } from '../subscribe-button';
import { StyledBar, StyledCopyWrapper, StyledWrapRow } from './top-bar.styles';
export const AfterSignupFlashSaleTopBar: FC<{
  hideCTA?: boolean;
  isEmbedded?: boolean;
}> = ({
  hideCTA,
  isEmbedded
}) => {
  const influencerCampaign = FlashSaleCampaignName.FLASH_SALE_CYBERAWARENESS_2025;
  const theme = useTheme();
  const {
    data: userDataResponse
  } = useGetUserQuery();
  const [ctaText, loggedUserUrlToNavigate] = useCampaignCta(undefined, '& save 25%');
  const {
    data: campaigns
  } = useGetInfluencersCampaignsQuery({
    page: 1,
    limit: 1,
    name: influencerCampaign
  });
  const campaignData = campaigns?.data?.docs[0];
  const campaignConfigs = useInfluencerSubscriptionCampaign(influencerCampaign, campaignData);
  const flashSaleEndTime = useGetAfterSignupFlashSaleEndTime(campaignConfigs.campaign, userDataResponse?.data?.user?.dateSignUp);
  const additionalConfigs = useInfluencerConfigs(campaignData);
  if (!campaignConfigs || !additionalConfigs) return null;
  const {
    campaign,
    isInCurrentInfluencerSession
  } = campaignConfigs;
  const {
    urlToNavigate,
    percentageOff
  } = additionalConfigs;
  const url = userDataResponse?.data ? loggedUserUrlToNavigate : urlToNavigate;
  if (!campaign) return null;
  return !!isInCurrentInfluencerSession && !!campaignData ? <ThemeProvider theme={{
    ...theme,
    colors: lightColors
  }}>
      <StyledBar isEmbedded={isEmbedded} role="region" aria-label="Flash Sale Special Offer">
        <StyledCopyWrapper>
          <p data-testid="campaign-promotion-text">
            LEVEL UP YOUR LEARNING: <span>{percentageOff}% OFF</span> ANNUAL SUBSCRIPTIONS
          </p>
        </StyledCopyWrapper>
        <StyledWrapRow>
          {!hideCTA && <SubscribeButton to={url} aria-label={ctaText}>
              {ctaText}
            </SubscribeButton>}
          {flashSaleEndTime && <Countdown vertical dark includeDays endTime={flashSaleEndTime} />}
        </StyledWrapRow>
      </StyledBar>
    </ThemeProvider> : null;
};